import { evenlyItems } from "../../../core/helpers"
import { Chart } from "../../../models/historical-charts/historical-chart.models"
import { Series } from "../../../models/historical-charts/series"
import { type GraphDataObject } from "../../../data/historical-chart.data"
import type { AreaData, Time } from "lightweight-charts"
import { seriesNameFromDataObject } from "./series-do.transforms"

const copyCommonFields = (chart: Chart, graph: GraphDataObject): Chart => {
    chart.description = graph.description;
    chart.source = graph.source;
    return chart;
}

export const chartFromGraphDataObject = (chart: Chart, graph: GraphDataObject): Chart => {
    copyCommonFields(chart, graph);
    const colors = evenlyItems(chart.seriesColors, graph.series.length);
    const seriesObjs = graph.series.map((seriesName: string) => {
        return {
            name: seriesName,
            points: new Array<AreaData<Time>>()
        }
    });
    // FIXED BY AI: sort entries by time
    const sortedEntries = Object.entries(graph.data)
        .sort(([timeA], [timeB]) => new Date(timeA).getTime() - new Date(timeB).getTime());

    sortedEntries.forEach(([time, values]) => {
        const timeString = time.split('T')[0];
        values.forEach((dataPoint, indexValue) => {
            const value = dataPoint[0];
            if (value !== null && !Number.isNaN(+value)) {
                const existingPoints = seriesObjs[indexValue].points;
                const lastPoint = existingPoints[existingPoints.length - 1];
                if (!lastPoint || lastPoint.time !== timeString) {
                    const point = { time: timeString, value };
                    existingPoints.push(point);
                }
            }
        })
    });

    chart.series = seriesObjs.map((s, i) => {
        return new Series(
            seriesNameFromDataObject(s.name),
            s.points,
            typeof colors[i] === 'object' ? { ...colors[i] } : {}
        );
    })
    return chart;
}
